module.exports = __webpack_public_path__ + "fonts/mulish-v11-latin-300italic.79d89f4.woff";